import QS from 'qs'
import './index.scss'
import _ from 'lodash'
import { useLocation } from 'react-router-dom'
import { purchaseListPromise } from 'api/Purchase'
import { PurchaseToolbar, PurchaseTable } from './components'
import React, { useState, useEffect, useCallback, useRef } from 'react'

const PurchaseList = props => {
  const ref = useRef()
  const location = useLocation()
  const [purchases, setPurchases] = useState({})
  const [params, setParams] = useState({ page: 1 })

  // start
  // load data
  useEffect(() => {
    const foo = QS.myParse(location.search)
    setParams({ page: 1, ...foo })
    purchaseListPromise(foo).then(resp => setPurchases(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = QS.myParse(location.search)
    const too = _.pickBy({ ...foo, page: 1, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${QS.stringify(too)}`), delay)
  }, [location.search, props.history])

  function handlePageChange (event, page) {
    handleParamsChange({ page: page + 1 })
  }

  function handleSearchChange (payload) {
    handleParamsChange(payload, 500)
  }
  // end

  return (
    <div className={'root'}>
      <PurchaseToolbar params={params} onSearchChange={handleSearchChange} />
      <div className={'content'}>
        <PurchaseTable data={purchases || {}} page={params.page} onPageChange={handlePageChange} {...props} />
      </div>
    </div>
  )
}

export default PurchaseList